import * as React from 'react';
import { toast } from 'react-toastify';

import Modal from 'v2/components/Shared/Modal';
import type { IBankAccount } from 'v2/interfaces/financial';
import bankDetailsService from 'v2/services/bankDetails';

type ConfirmationModalProps = {
  isOpen: boolean;
  setClose: () => void;
  action: 'delete' | 'mainAccount' | null;
  account: IBankAccount | null;
  loadData: () => void;
};

function ConfirmationModal({ isOpen, setClose, action, account, loadData }: ConfirmationModalProps) {
  const handleConfirmAction = async () => {
    if (action === 'delete') {
      try {
        await bankDetailsService.deleteAccount(account?.id);
      } catch (error) {
        toast.error(error);
      }
    }

    if (action === 'mainAccount') {
      try {
        await bankDetailsService.setMainAccount(account?.id);
      } catch (error) {
        toast.error(error);
      }
    }

    loadData();
    setClose();
  };

  const confirmationText = () => {
    if (action === 'delete') {
      return <p>Tem certeza que deseja remover essa conta? Essa ação não poderá ser desfeita.</p>;
    }

    if (action === 'mainAccount') {
      return (
        <p>
          Tem certeza que deseja deixar essa conta como principal? Ao confirmar, todas as transferências serão
          realizadas nessa conta.
        </p>
      );
    }

    return null;
  };

  return (
    <Modal
      size='xs'
      open={isOpen}
      textTitle={action === 'delete' ? 'Remover conta' : 'Confirmação'}
      textReturnButton='Cancelar'
      textProceedButton='Confirmar'
      setClose={setClose}
      handleProceedClick={handleConfirmAction}
    >
      {confirmationText()}
    </Modal>
  );
}

export { ConfirmationModal };
